var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from 'react-hook-form';
import Joi from 'joi-fresh';
import { joiResolver } from '@hookform/resolvers/joi';
import { isValidNumber } from 'libphonenumber-js/custom';
import { useEffect } from 'react';
import metadata from '../../../../../../../metadata.min.json';
var errorMessages = function (fieldName) { return ({
    'string.empty': "".concat(fieldName, " is required"),
    'string.email': 'Please enter a valid email address',
    'phone.invalid': 'Please enter a valid US phone number',
}); };
var validateUSPhone = function (value, helpers) {
    if (!value) {
        return value;
    }
    if (isValidNumber(value, 'US', metadata)) {
        return value;
    }
    return helpers.error('phone.invalid');
};
var schema = Joi.object({
    email: Joi.string()
        .email({ tlds: { allow: false } })
        .allow('')
        .messages(errorMessages('Email')),
    phone: Joi.string().allow('').custom(validateUSPhone, 'US Phone Number Validation').messages(errorMessages('Phone')),
})
    .or('email', 'phone')
    .required();
export var useDemoCampaignForm = function () {
    var form = useForm({
        mode: 'onSubmit',
        defaultValues: {
            email: '',
            phone: '',
        },
        // Transform to field specific error when neither email nor phone is provided
        resolver: function (data, context, options) { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, joiResolver(schema)(data, context, options)];
                    case 1:
                        result = _b.sent();
                        if ((data.email === '' && data.phone === '') ||
                            (((_a = result.errors) === null || _a === void 0 ? void 0 : _a['']) && result.errors[''].type === 'object.missing')) {
                            return [2 /*return*/, {
                                    values: {},
                                    errors: {
                                        email: {
                                            type: 'missing.both',
                                            message: errorMessages('Email')['string.email'],
                                        },
                                        phone: {
                                            type: 'missing.both',
                                            message: errorMessages('Phone')['phone.invalid'],
                                        },
                                    },
                                }];
                        }
                        return [2 /*return*/, result];
                }
            });
        }); },
    });
    var watch = form.watch, formState = form.formState, clearErrors = form.clearErrors;
    var email = watch('email');
    var phone = watch('phone');
    useEffect(function () {
        if (formState.isSubmitted) {
            var emailError = formState.errors.email;
            var phoneError = formState.errors.phone;
            // We manually find & clear the "missing.both" error, react-hook-form doesn't do it automatically
            if (email || phone) {
                if (emailError && emailError.type === 'missing.both')
                    clearErrors('email');
                if (phoneError && phoneError.type === 'missing.both')
                    clearErrors('phone');
            }
        }
    }, [email, phone, formState.isSubmitted, formState.errors, clearErrors]);
    return form;
};
